import React, { useState } from "react";
import { LoginForm } from "@/components/auth/LoginForm";
import { SignUpForm } from "@/components/auth/SignUpForm";
import { RoleSelector } from "@/components/auth/RoleSelector";
import { CouponStep } from "@/components/auth/CouponStep";

export type PartnerType = "influencer" | "staff";

export interface SignUpData {
  name: string;
  email: string;
  password: string;
  phone: string;
  socialMedia: string;
  acceptTerms: boolean;
}

type AuthView = "login" | "select-role" | "signup" | "choose-coupon";

export const AuthPage: React.FC = () => {
  const [view, setView] = useState<AuthView>("login");
  const [partnerType, setPartnerType] = useState<PartnerType>("influencer");
  const [signUpData, setSignUpData] = useState<SignUpData | null>(null);

  const handleRoleSelected = (type: PartnerType) => {
    setPartnerType(type);
    setView("signup");
  };

  const handleSignUpNext = (data: SignUpData) => {
    setSignUpData(data);
    setView("choose-coupon");
  };

  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center p-4 sm:p-6 lg:p-8 font-sans">
      <div className="w-full max-w-md lg:max-w-lg xl:max-w-xl mx-auto">
        {view === "login" && (
          <LoginForm onSwitchToSignUp={() => setView("select-role")} />
        )}
        {view === "select-role" && (
          <RoleSelector
            onSelect={handleRoleSelected}
            onBack={() => setView("login")}
          />
        )}
        {view === "signup" && (
          <SignUpForm
            partnerType={partnerType}
            onNext={handleSignUpNext}
            onSwitchToLogin={() => setView("login")}
            onBack={() => setView("select-role")}
            defaultValues={signUpData}
          />
        )}
        {view === "choose-coupon" && signUpData && (
          <CouponStep
            signUpData={signUpData}
            partnerType={partnerType}
            onBack={() => setView("signup")}
            onComplete={() => setView("login")}
          />
        )}
      </div>
    </div>
  );
};
